<template>
  <div>
    <el-dialog
      title="免费试用申请"
      :visible.sync="dialogVisible"
      :width="IsPC()?'1200px':'300px'"
      top="2%"
      custom-class="free-dialog"
      append-to-body
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div class="apply-box">
        <el-form :model="formData" :rules="rules" ref="formData" label-width="100px" class="demo-formData">
          <el-row :gutter="80">
            <el-col :span="colSpan">
              <el-form-item label="姓名：" prop="name">
                <el-input v-model="formData.name" placeholder="请输入您的真实姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item label="职位：" prop="position">
                <el-input v-model="formData.position" placeholder="请输入您的职位名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item label="手机号码：" prop="phone">
                <el-input v-model="formData.phone" placeholder="请输入您的手机号码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item label="行业：" prop="industry">
                <el-input v-model="formData.industry" placeholder="请填写您的所属行业"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item label="企业名称：" prop="company">
                <el-input v-model="formData.company" placeholder="请输入您的企业名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item label="企业人数：" prop="personCount">
                <el-input v-model="formData.personCount" placeholder="请输入您的企业人数"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item label="企业所在省市：" prop="region">
                <el-input v-model="formData.region" placeholder="请输入您企业的所在位置"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer">
        <el-button class="dialog-footer" type="primary" @click="submitForm('formData')">提交申请</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { checkEmail, checkMobilePhone, zeroInt } from '@/filters'
import { IsPC } from "@/utils"
import { addTriaRecord } from "@/api/device"
export default {
  data (){
    return{
      dialogVisible: false,
      colSpan: 12,
      formData: {
        name: '', //姓名
        position: '', //职位
        phone: '', //电话
        industry: '', //行业
        company: '', //企业名称
        region: '', //企业所在省市
        personCount: '', //公司人数
      },
      rules:{
        name: [
          { required: true, message: '请输入您的真实姓名', trigger: 'change' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        position: [
          // { required: true, message: '请输入您的职位名称', trigger: 'change' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入您的手机号码', trigger: 'change' },
          { validator: checkMobilePhone, trigger: ['change'] },
        ],
        industry: [
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
          // { validator: checkEmail, trigger: ['change'] },
          // { required: true, message: '请填写您的邮箱地址', trigger: 'change' },
        ],
        company: [
          { required: true, message: '请输入您的企业名称', trigger: 'change' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        region: [
          // { required: true, message: '请输入您企业的所在位置', trigger: 'change' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        personCount: [
          { validator: zeroInt, trigger: ['change'] },
          // { required: true, message: '请填写您的需求', trigger: 'change' },
          { min: 1, max: 6, message: '长度在 1 到 6 个字符', trigger: 'blur' }
        ],
      }
    }
  },
  created(){
    this.colSpan = this.IsPC() ? 12: 24
     //  console.log(this.colSpan);
  },
  methods: {
    IsPC,
    handleOpen(){
      this.dialogVisible = true
    },
    handleClose(){
      if(this.$refs.formData){
        this.$refs.formData.resetFields()
      }
      this.dialogVisible = false
    },
     submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addInfo()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
     },
     getParams(){
       let params = {...this.formData}
       return params
     },
     addInfo () {
       let params = this.getParams()
       addTriaRecord(params).then(res => {
          if (res.code === '0') {
            this.handleClose()
            this.$confirm('您的信息已提交系统审核，我们会在1-3个工作日内联系您，并分配试用账号，感谢您的支持！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'success',
              showCancelButton: false
            }).then(() => {}).catch(() => {});
          } else {
            this.$message({
              message: response.message,
              type: 'error'
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
     },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .apply-box{
  border-top: 1px solid #f0f0f0;
  padding-top: 40px;
  .el-form-item{
    .el-form-item__label{
      display: block;
      width: 100% !important;
      text-align: left;
    }
    .el-form-item__content{
      margin-left: 0 !important;
    }
  }
}
/deep/ .el-dialog__footer{
  text-align: center;
  padding-bottom: 40px;
  .dialog-footer{
    width: 100px;
    border-radius: 0;
    background-color: #1169de;
  }
}
/deep/ .free-dialog{
  .el-dialog__header{
    text-align: center;
    font-size: 26px;
    letter-spacing: 1px;
    font-weight: bold;
    padding: 50px 0 20px 0;
    .el-dialog__title{
      font-size: 26px;
    }
  }
  .el-dialog__body{
    padding: 30px 100px;
  }
  .el-dialog__close{
    font-size: 24px;
    color: rgba(60, 60, 67, 0.5);
  }
}

//  - -------------------- 移动端 ----------------------
@media screen and (max-width: 1000px) and (min-width: 300px){
  /deep/ .free-dialog{
    .el-dialog__header{
      padding: 10px 0 0 20px;
      text-align: left;
      .el-dialog__title{
        font-size: 20px;
      }
    }
    .el-dialog__headerbtn{
      top: 10px;
    }
    .el-dialog__body{
      padding: 10px 20px;
    }
    .apply-box{
      padding-top: 10px;
    }
    .el-dialog__footer{
      padding-bottom: 20px;
      padding-top: 0;
    }
  }

}
//  - -------------------- 移动端 ----------------------
</style>


// WEBPACK FOOTER //
// src/views/components/freeDialog.vue